import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { isAllowed } from 'helpers';
import { Link } from 'react-router-dom';

export const getColumns = (intl, user, handleDeleteUser, displayRoleDetail) => [
  {
    field: 'name',
    headerName: intl.formatMessage({
      id: 'app.roles.grid.nameCol',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'created_at',
    headerName: intl.formatMessage({
      id: 'app.roles.grid.creatDateCol',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    renderCell: (params) => {
      // Crear un objeto Date con la fecha recibida
      const date = new Date(params.row.created_at);

      // Formatear la fecha usando Intl con formato personalizado
      const formattedDate = intl.formatDate(date, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });

      // Obtener la hora y minutos
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      // Devolver la fecha y la hora concatenadas
      return <span>{`${formattedDate} ${hours}:${minutes}`}</span>;
    },
  },
  {
    headerName: intl.formatMessage({
      id: 'app.roles.grid.roleDetailCol',
    }),
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    renderCell: (rowData) => (
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={() => displayRoleDetail(rowData.row)}
      >
        {intl.formatMessage({
          id: 'app.roles.grid.roleDetailCol.msg',
        })}
      </Button>
    ),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    renderCell: (params) => {
      const actions = [];
      if (isAllowed(user.permissions, ['role_delete'])) {
        actions.push(
          <Tooltip
            title={intl.formatMessage({
              id: 'app.metusers.grid.colAction.delete',
            })}
          >
            <IconButton
              onClick={() => handleDeleteUser(params.row)}
              color="error"
              aria-label={intl.formatMessage({
                id: 'app.metusers.grid.colAction.delete',
              })}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        );
      }

      if (isAllowed(user.permissions, ['role_update'])) {
        actions.push(
          <Link
            to={{
              pathname: `/updateRole/${params.row.id}`,
              state: { rowData: params.row },
            }}
            style={{ textDecoration: 'none' }}
          >
            <Tooltip
              title={intl.formatMessage({
                id: 'app.metusers.grid.colAction.edit',
              })}
            >
              <IconButton
                aria-label={intl.formatMessage({
                  id: 'app.metusers.grid.colAction.edit',
                })}
                color="secondary"
              >
                <Edit />
              </IconButton>
            </Tooltip>
          </Link>
        );
      }
      return actions;
    },
    flex: 1,
    align: 'center',
    headerAlign: 'center',
  },
];
